export const lineConfig = {
    VUE_APP_LINE_CLIENT_ID: '2001845190',
    VUE_APP_LINE_CLIENT_SECRET: '020b952c15697f6df3cd5ac7a6c9f549',
    // VUE_APP_LINE_CALLBACK_URL: 'http://localhost:8080/line-callback',
    VUE_APP_LINE_CALLBACK_URL: 'https://thaisook-admin.web.app/line-callback',
    defaultLinePassword: 'Tha1S00kL1neL0g1n'
};